// @ts-nocheck
import React from "react";
import { useDispatch } from "react-redux";
import { incrementProductAmount, decrementProductAmount } from "../stores/cart/cartSlice";
import { FaMinus, FaPlus } from "react-icons/fa";

export const ProductsSummaryCard = ({ product }) => {
    const dispatch = useDispatch();

    return (
        <div className="flex gap-4 p-3 bg-white border border-slate-50 rounded-2xl animate-app-reveal hover:border-slate-100 transition-colors shadow-[0_2px_8px_-4px_rgba(0,0,0,0.05)]">
            {/* Ultra-Sharp Thumbnail */}
            <div className="relative w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden border border-slate-100 bg-slate-50">
                <img
                    src={product.imageUrl}
                    alt={product.name}
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Product Meta: Space-Wise Layout */}
            <div className="flex-1 min-w-0 flex flex-col justify-center">
                <h3 className="text-m font-bold text-slate-900 leading-tight truncate">{product.name}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-sm font-black text-indigo-600">{product.price} <span className="text-[10px] uppercase tracking-tighter opacity-60">ALL</span></span>
                    {product.euroPrice && (
                        <span className="text-[11px] font-bold text-slate-400">/ {product.euroPrice} €</span>
                    )}
                </div>
            </div>

            {/* Smart Quantity Control */}
            <div className="flex items-center gap-2.5 bg-slate-50 px-2 py-1.5 rounded-xl border border-slate-100 self-center">
                <button
                    onClick={() => dispatch(decrementProductAmount(product))}
                    disabled={product.amount <= 0}
                    className="w-7 h-7 flex items-center justify-center rounded-lg bg-white shadow-sm text-slate-900 active:scale-90 transition-all disabled:opacity-30"
                >
                    <FaMinus size={8} />
                </button>
                <span className="text-sm font-black text-slate-900 w-4 text-center">{product.amount}</span>
                <button
                    onClick={() => dispatch(incrementProductAmount(product))}
                    className="w-7 h-7 flex items-center justify-center rounded-lg bg-slate-900 text-white shadow-md active:scale-90 transition-all"
                >
                    <FaPlus size={8} />
                </button>
            </div>
        </div>
    );
};
